(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Context', Context);

    Context.$inject = ['$resource'];

    function Context($resource) {
        var context = $resource('api/context', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'delete': {method: 'DELETE'}
        });

        return context;
    }
})();
